module.exports = __webpack_public_path__ + "assets/metrics-checkmark.8b2ddb36.svg";